

































































import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import SliderToggler from "_C/main/Step4/SliderToggler.vue";
import DriversHost from "_C/main/Step4/DriversHost.vue";
import { DefaultCopy } from "_P/copyobj";
import { InsuranceCard, Driver } from "@/services/index.defs";
@Component({
    components: { DriversHost, SliderToggler },
})
export default class DriversDisplay extends Vue {
    get card(): InsuranceCard {
        return this.$store.direct.state.insurance.card;
    }

    fakeDrivers: Driver[] = DefaultCopy(this.card.drivers) as Driver[];

    @Ref("form") form: { validate: Function };
    applyChanges() {
        let isValid = this.form.validate();
        if (!isValid) {
            this.cancelChanges();
            return;
        }

        this.card.drivers = DefaultCopy(this.fakeDrivers) as Driver[];
    }
    cancelChanges() {
        this.fakeDrivers = DefaultCopy(this.card.drivers) as Driver[];
    }
    @Ref("st") st: SliderToggler;
    isEdit(): boolean{
        return this.st.isEdit
    }
}
